
export default {
  SENTRY: {
    DSN: 'https://64edab8ed38c4906aea715e58b6b2dd2@sentry.io/1724732',
    enableLocalhost: false,
  },
}
